import { FieldTitle } from '@components/FieldTitle/FieldTitle';
import { Ionicons } from '@expo/vector-icons';
import { Pressable, StyleSheet } from 'react-native';
import { SizableText, XStack, YStack, useTheme } from 'tamagui';
import { DEFAULT_DATE_PLACEHOLDER } from './dateField.utils';

interface DateFieldShellProps {
  label?: string;
  required?: boolean;
  valueText: string;
  placeholder?: string;
  onPress: () => void;
  onDelete?: () => void;
}

export const DateFieldShell = ({
  label,
  required = false,
  valueText,
  placeholder = DEFAULT_DATE_PLACEHOLDER,
  onPress,
  onDelete,
}: DateFieldShellProps): React.ReactElement => {
  const theme = useTheme();
  const iconColor = theme.color?.val;
  const hasValue = valueText.length > 0;
  const showDeleteIcon = hasValue && onDelete;

  return (
    <YStack space="$2">
      <FieldTitle label={label} required={required} />

      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel={label}
        style={styles.fieldPressable}
      >
        <XStack
          backgroundColor="$tertiary50"
          borderRadius="$true"
          paddingHorizontal="$3"
          paddingVertical="$3"
          alignItems="center"
          gap="$3"
          minHeight="$true"
          justifyContent="space-between"
        >
          <SizableText
            size="$1"
            color={hasValue ? '$color' : '$secondary75'}
            flex={1}
            textAlign="left"
          >
            {hasValue ? valueText : placeholder}
            {!label && required && !hasValue && (
              <SizableText size="$2" color="$brand">
                {' '}
                *
              </SizableText>
            )}
          </SizableText>

          {showDeleteIcon ? (
            <Pressable
              onPress={onDelete}
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            >
              <Ionicons name="close-circle" size={20} color={iconColor} />
            </Pressable>
          ) : (
            <Ionicons
              name="calendar-clear-outline"
              size={20}
              color={iconColor}
            />
          )}
        </XStack>
      </Pressable>
    </YStack>
  );
};

const styles = StyleSheet.create({
  fieldPressable: {
    flex: 1,
    width: '100%',
  },
});
